import * as React from "react";
import type { SVGProps } from "react";
const SvgSortDefault1Icon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="sort_default1_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M465.579 105.43 230.656 356.01c-38.101 40.662-9.259 107.137 46.421 107.137h469.846c55.68 0 84.48-66.475 46.421-107.094L558.421 105.387a63.616 63.616 0 0 0-92.842 0zm91.818 815.829 230.187-204.63c46.933-41.728 17.45-119.381-45.355-119.381H281.771c-62.806 0-92.331 77.653-45.355 119.381l230.187 204.63c25.898 23.04 64.896 23.04 90.794 0z"
    />
  </svg>
);
export default SvgSortDefault1Icon;
